function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clipEmfPath1"
}, React.createElement("path", {
  d: "m0.32013 0.48019h41.937v41.777h-41.937z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0.59568 20.074c0-10.767 8.7071-19.513 19.435-19.513 10.748 0 19.435 8.746 19.435 19.513 0 10.787-8.6877 19.513-19.435 19.513-10.728 0-19.435-8.7265-19.435-19.513z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  transform: "matrix(.97139 0 0 .97139 -.57045 -.60537)",
  d: "m1.2005 21.288c0-11.084 8.9636-20.088 20.008-20.088 11.064 0 20.008 9.0036 20.008 20.088 0 11.104-8.9436 20.088-20.008 20.088-11.044 0-20.008-8.9836-20.008-20.088",
  clipPath: "url(#clipEmfPath1)",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: 1.0295
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-primary",
  d: "m15.516 7.7968c0-0.73238 0.59443-1.326 1.3273-1.326h6.3068c0.73284 0 1.3273 0.59364 1.3273 1.326v5.3041c0 0.73238-0.59443 1.3261-1.3273 1.3261h-6.3068c-0.73284 0-1.3273-0.59374-1.3273-1.3261z",
  fill: "#ecaec6",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: 0.33333
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  transform: "translate(0,2)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 8.6667
}, React.createElement("path", {
  d: "m20.031 12.725v6.8588"
}), React.createElement("path", {
  d: "m7.9288 19.74v-3.1351h24.071v3.2919"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-secondary",
  transform: "translate(0,2)",
  fill: "#adb9ca",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: 0.33333
}, React.createElement("path", {
  d: "m3.5755 20.899c0-0.72599 0.58983-1.3144 1.317-1.3144h6.2579c0.72716 0 1.317 0.58846 1.317 1.3144v5.2578c0 0.72599-0.58983 1.3145-1.317 1.3145h-6.2579c-0.72716 0-1.317-0.58856-1.317-1.3145z"
}), React.createElement("path", {
  d: "m15.516 20.899c0-0.72599 0.58983-1.3144 1.317-1.3144h6.2579c0.72716 0 1.317 0.58846 1.317 1.3144v5.2578c0 0.72599-0.58983 1.3145-1.317 1.3145h-6.2579c-0.72716 0-1.317-0.58856-1.317-1.3145z"
}), React.createElement("path", {
  d: "m27.542 20.899c0-0.72599 0.58752-1.3144 1.3118-1.3144h6.2335c0.72432 0 1.3118 0.58846 1.3118 1.3144v5.2578c0 0.72599-0.58752 1.3145-1.3118 1.3145h-6.2335c-0.72432 0-1.3118-0.58856-1.3118-1.3145z"
}));

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m15.524 7.8017c0-0.73238 0.59443-1.326 1.3273-1.326h6.3068c0.73284 0 1.3273 0.59364 1.3273 1.326v5.3041c0 0.73238-0.59443 1.3261-1.3273 1.3261h-6.3068c-0.73284 0-1.3273-0.59374-1.3273-1.3261z",
  fill: "none",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeMiterlimit: 8.6667
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  transform: "translate(.048506 1.9987)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeMiterlimit: 8.6667
}, React.createElement("path", {
  d: "m3.5755 20.899c0-0.72599 0.58983-1.3144 1.317-1.3144h6.2579c0.72716 0 1.317 0.58846 1.317 1.3144v5.2578c0 0.72599-0.58983 1.3145-1.317 1.3145h-6.2579c-0.72716 0-1.317-0.58856-1.317-1.3145z"
}), React.createElement("path", {
  d: "m15.516 20.899c0-0.72599 0.58983-1.3144 1.317-1.3144h6.2579c0.72716 0 1.317 0.58846 1.317 1.3144v5.2578c0 0.72599-0.58983 1.3145-1.317 1.3145h-6.2579c-0.72716 0-1.317-0.58856-1.317-1.3145z"
}), React.createElement("path", {
  d: "m27.542 20.899c0-0.72599 0.58752-1.3144 1.3118-1.3144h6.2335c0.72432 0 1.3118 0.58846 1.3118 1.3144v5.2578c0 0.72599-0.58752 1.3145-1.3118 1.3145h-6.2335c-0.72432 0-1.3118-0.58856-1.3118-1.3145z"
}));

var SvgOrgStructure = function SvgOrgStructure(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOrgStructure, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Org-Structure.a42311ee.svg";
export { ForwardRef as ReactComponent };